// 角色模板列表
<template>
  <div class="content" v-loading.fullscreen.lock="fullscreenLoading">
    <!-- search start -->
    <div class="search-area">
      <el-row :gutter="24" style="height:34px">
        <el-col :span="6">
          <div class="search-area-div">模板名称</div>
          <el-input size="mini" class="ipt-sty" v-model="page.templateName" placeholder="请输入" filterable> </el-input>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">应用端</div>
          <el-select size="mini" class="ipt-sty" v-model="page.appSideGuid" placeholder="请选择" filterable>
            <el-option v-for="item in appsideList" :label="item.appSideName" :value="item.guid" :key="item.guid">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6" class="search-btn-box">
          <el-button size="mini" type="info" @click="getList">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
        </el-col>
      </el-row>
    </div>
    <!-- search end -->

    <!-- table start -->
    <div class="back-color-fff content-main-box" :style="'height:' + contentMainHeight + 'px'">
      <div class="button-area">
        <el-button size="mini" type="info" @click="addTemplet" v-loading.fullscreen.lock="fullscreenLoading"
          >添加模板</el-button
        >
      </div>
      <el-table :height="tableHeight" :data="tableData" stripe border style="width: 100%" v-loading="tableLoading">
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="templateName"
          label="模板名称"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="220"
        >
          <template slot-scope="scope">{{ scope.row.templateName || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="appSideName"
          label="应用端"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="80"
        >
          <template slot-scope="scope">{{ scope.row.appSideName||'-' }}</template>
        </el-table-column>
        <el-table-column
          prop="remark"
          label="备注说明"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="190"
        >
          <template slot-scope="scope">{{ scope.row.remark||'-' }}</template>
        </el-table-column>
        <el-table-column
          prop="menuNum"
          label="菜单数量（个）"
          show-overflow-tooltip
          header-align="center"
          align="right"
          width="110"
        >
          <template slot-scope="scope">{{ scope.row.menuNum }}</template>
        </el-table-column>
        
        <el-table-column
          prop="createUserName"
          label="操作人"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="86"
        >
          <template slot-scope="scope">{{ scope.row.updateUserName ||scope.row.createUserName || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="操作时间"
          show-overflow-tooltip
          header-align="center"
          align="right"
          width="160"
        >
          <template slot-scope="scope">{{ (scope.row.updateTime || scope.row.createTime) | getTimeDate }}</template>
        </el-table-column>
        
        <el-table-column
          prop="bizState"
          label="启用状态"
          show-overflow-tooltip
          header-align="center"
          align="center"
          width="80"
        >
          <template slot-scope="scope">
            <el-tag size="mini" v-if="scope.row.bizState" :type="type[scope.row.bizState]">{{
              isUseObj[scope.row.bizState] || '-'
            }}</el-tag>
            <span v-else>{{ '-' }}</span>
          </template>
        </el-table-column>
        <el-table-column width="80" prop="createTime" label="界面排序" header-align="center" align="right">
          <template slot-scope="scope">{{ scope.row.orderNum||'-' }}</template>
        </el-table-column>
        <el-table-column prop="bank" min-width="150" label="操作" header-align="center" align="center" fixed="right">
          <template slot-scope="scope">
            <div>
              
              <a class="txt-color" v-if="scope.row.bizState === 'Y'" @click="toUse(scope.row, 'S')">停用 | </a>
              <a class="txt-color" v-if="scope.row.bizState === 'S'" @click="toUse(scope.row, 'Y')">启用 | </a>
              <a class="txt-color" @click="toEdit(scope.row)">编辑 | </a>
              <a class="txt-color" @click="toEdit(scope.row,1)">复制 | </a>
              <a
                class="txt-color"
                @click="delAdv(scope.row.guid, scope.row)"
                >删除</a
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff content-pagination-box"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 20, 50, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
    <!-- table end -->
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
export default {
  data() {
    let userinfo = JSON.parse(localStorage.userInfo);
    return {
      userinfo: userinfo,
      showMore: false,
      tableHeight: window.innerHeight - 263,
      contentMainHeight: window.innerHeight - 200,
      fullscreenLoading: false,
      tableData: [],
      invoiceDate: [], // 开票日期
      page: {
        pageIndex: 1,
        pageSize: 50,
        templateName: '', //模板名称
        appSideGuid: '', //应用端guid
      },
      invoiceTenantList: [],
      receiveTenantList: [],
      type: {
        Y: 'success',
        S: 'info',
      },
      isUseObj: {
        Y: '启用',
        S: '停用',
      },
      appsideList: [],
    };
  },
  filters: {
    havePic(val) {
      return val ? '有' : '无';
    },
    supported(val) {
      return val === 'Y' ? '支持' : '不支持';
    },
  },
  watch: {
    showMore(val, oldVal) {
      if (val) {
        this.tableHeight = window.innerHeight - 310;
        return;
      }
      if (!val) {
        this.tableHeight = window.innerHeight - 263;
        this.contentMainHeight = window.innerHeight - 200;
        return;
      }
    },
  },
  created() {
    this.getList();
    this.getAppsideData()
  },
  beforeRouteEnter(to, from, next) {
    if (from.path === '/addTempletConfig') {
      next((vm) => {
        vm.getList();
      });
    } else {
      next();
    }
  },
  methods: {
    //添加角色模板
    addTemplet() {
      this.$router.push({
        path: '/addTempletConfig',
        query: {
          productGuid: localStorage.productGuid,
        },
      });
    },
    getName(name, key) {
      let list = this.getCodeListByKey(key);
      let lisArr = list.filter((item) => item.value == name);
      return lisArr.length ? lisArr[0].text : '-';
    },
    // search() {
    //   let self = this;
    //   self.tableLoading = true;
    //   self.api.postJson(`/${serverConfig.msConfigureService}/role-template/data/list`, this.page).then((res) => {
    //     self.tableLoading = false;
    //     if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
    //       self.tableData = res.data.data.records;
    //       self.page.totalPage = res.data.data.totalPages;
    //       self.page.totalRows = res.data.data.totalRows;
    //     } else {
    //       self.$message.error(res.data.msg);
    //     }
    //   });
    // },
    emptySearch() {
      this.invoiceDate = [];
      this.page = {
        pageIndex: 1,
        pageSize: 50,
        templateName: '', //模板名称
        appSideGuid: '', //应用端guid
      };
      this.getList();
      
      
    },
    addVersion() {
      this.$router.push('/upstreamInvoiceEdit?productGuid=' + this.$route.query.productGuid);
    },
    editForm(guid) {
      this.$router.push('/upstreamInvoiceEdit?guid=' + guid + '&productGuid=' + this.$route.query.productGuid);
    },
    lookForm(guid) {
      this.$router.push({
        path: '/upstreamInvoiceEdit',
        query: {
          guid: guid,
          operationMode: 'look',
          productGuid: this.$route.query.productGuid,
        },
      });
    },
    // 获取应用端列表
    getAppsideData(flg) {
      let self = this;
      self.loading = true;
      let promise = {
        guid: '',
        pageIndex: 1,
        appSideName: '',
        pageSize: 100,
        platformGuid: '1e2409b7ef0b412c2bb84e38f8fe50ba',
        startTime: '',
        endTime: '',
      };
      self.api.postJson(`/${serverConfig.msCommonAdminPlatformAuthService}/appside/data/get`, promise).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.loading = false;
          self.appsideList = res.data.data.records || [];
          
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getList() {
      let self = this;
      self.tableLoading = true;
      self.api.postJson(`/${serverConfig.msCommonAdminPlatformAuthService}/role-template/data/list`, this.page).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },
    // 去编辑
    toEdit(item,type) {
      this.$router.push({
        path: '/addTempletConfig',
        query: {
          guid: item.guid,
          isCopy:type
        },
      });
    },
    // 上/下架操作
    toUse(item, isUse) {
      let messageOjb = {
        Y: '启用后，此模版将开放使用，确定操作吗？',
        S: '停用后，此模版将无法使用，确定操作吗？',
      };
      let req={
        guid:item.guid,
        bizState:isUse
      }
      this.$confirm(messageOjb[isUse], {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let url = `/${serverConfig.msCommonAdminPlatformAuthService}/role-template/data/set-state`;
        this.fullscreenLoading = true;
        this.api.postJson(url, req).then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message({
              message: '操作成功',
              type: 'success',
            });
            this.getList();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    // 删除模板
    delAdv(guid, item) {
      if (item.bizState === 'Y') {
        this.$message({
          message: '请先停用模板再删除',
          type: 'error',
        });
        return;
      }
      this.$confirm('删除后不可恢复，确定要删除吗？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let url = `/${serverConfig.msCommonAdminPlatformAuthService}/role-template/data/delete`;
        this.api.postJson(url, [guid]).then((res) => {
          this.fullscreenLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message({
              message: '删除成功',
              type: 'success',
            });
            this.getList();
          } else {
            this.$message.error(res.data.msg);
          }
        });
      });
    },
    getName(name, key) {
      if (!name) return '-';
      let list = this.getCodeListByKey(key);
      if (typeof name == 'object') {
        let newArr = [];
        name.forEach((item) => {
          list.forEach((el) => {
            if (el.value == item) {
              newArr.push(el.text);
            }
          });
        });
        return newArr.length ? newArr.join('、') : '-';
      } else {
        let lisArr = list.filter((item) => item.value == name);
        return lisArr.length ? lisArr[0].text : '-';
      }
    },
  },
};
</script>

<style lang="less" scoped>
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}

.el-range-editor.el-input__inner {
  padding: 0px;
}

/deep/ .el-checkbox__label {
  display: none;
}

.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}

.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}

/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}

/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}

/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}

.el-col-6 {
  margin-bottom: 8px;
  display: flex;
}
.ipt-sty {
  flex: 1;
}
.search-area-div {
  width: 58px;
  text-align: right;
}
</style>
